import RoutesObject from "../../helpers/Routes";
import { AuthDTO } from "../../models/AuthDTO";

export class NavbarTitles {
    public name: string;
    public navbarItems: NavbarItem[];
    public readonly requiredRoles?: string[];

    constructor(name: string, navbarItems: NavbarItem[], requiredRoles?: string[]) {
        this.name = name;
        this.navbarItems = navbarItems;
        this.requiredRoles = requiredRoles;
    }


}

export class SettingValue {

    public async initializeNavbar(): Promise<NavbarTitles[]> {

        // Dropdown para as assistências
        const FirstDropdown: NavbarTitles = new NavbarTitles("Assistências", [
            new NavbarItem("Navbar.Tab.Home", "/"),
            new NavbarItem("Navbar.Tab.Equipments", RoutesObject.equipments.list),
            new NavbarItem("Navbar.Tab.Projects", RoutesObject.projects.list, ["Técnico Escritório", "Admin"], "ProjectSage50cIsActiveProjectModule"),
            new NavbarItem("Navbar.Tab.ClientQuotation", RoutesObject.clientQuotations.list, ["Técnico Escritório", "Admin"], "IsActiveClientQuotation"),
            new NavbarItem("Navbar.Tab.SupplierQuotation", RoutesObject.supplierQuotations.list, ["Técnico Escritório", "Admin"], "IsActiveSupplierQuotation"),
            new NavbarItem("Navbar.Tab.MaintenancePlans", RoutesObject.maintenancePlans.list, ["Técnico Escritório", "Admin"], "IsActiveMaintenanceModule"),
            new NavbarItem("Navbar.Tab.DeliveryNotes", RoutesObject.deliveryNotes.list, ["Técnico Escritório", "Admin"], "isActiveStockManagement"),
            // new NavbarItem("Navbar.Tab.Kpi", RoutesObject.kpis.list,["Técnico Escritório","Admin"], "isActiveKpiModule" ),
            new NavbarItem("Navbar.Tab.Kpi.Client.Dashboard", RoutesObject.kpis.list6 ?? 'Rota Undefined', ["Técnico Escritório", "Admin"], "isActiveKpiModule"),
            new NavbarItem("Navbar.Tab.Kpi.Technician.Dashboard", RoutesObject.kpis.list5 ?? 'Rota Undefined', ["Técnico Escritório", "Admin"], "isActiveKpiModule", true),
        ]);

        // Dropdown para definições
        const SecondDropdown: NavbarTitles = new NavbarTitles("Definições", [
            new NavbarItem("Navbar.Tab.Clients", RoutesObject.clients.list, ["Técnico Escritório", "Admin"]),
            new NavbarItem("Navbar.Tab.Subcontractors", RoutesObject.subcontractors.list, ["Técnico Escritório", "Admin"], "IsActiveOutsourcingModule"),
            new NavbarItem("Navbar.Tab.Parts", RoutesObject.parts.list, ["Técnico Escritório", "Admin"]),
            new NavbarItem("Navbar.Tab.Suppliers", RoutesObject.suppliers.list, ["Técnico Escritório", "Admin"], "IsActiveSuppliersModule"),
            new NavbarItem("Navbar.Tab.AuxiliaryEquipments", RoutesObject.auxiliaryEquipments.list, ["Técnico Oficina", "Técnico Escritório", "Admin"], "IsActiveAuxiliaryEquipments"),
            new NavbarItem("Navbar.Tab.CheckLists", RoutesObject.checkListModels.list, ["Técnico Escritório", "Admin"], "IsActiveCheckListModule"),
            new NavbarItem("Navbar.Tab.Counters", RoutesObject.counterTypes.list, ["Técnico Escritório", "Admin"], "IsActiveEquipmentCountersModule"),
        ], ["Técnico Escritório", "Admin"]);

        // Dropdown para o calendário
        const ThirdDropdown: NavbarTitles = new NavbarTitles("Calendário", [
            new NavbarItem("Navbar.Tab.Scheduler", RoutesObject.scheduler.list, ["Técnico Oficina", "Técnico Escritório", "Admin"], "IsActiveScheduler"),
            new NavbarItem("Navbar.Tab.Reminder", RoutesObject.reminders.list, ["Técnico Escritório", "Admin"], "IsActiveMaintenanceModule"),
        ]);

        // Dropdown para o KPIs
        const KpisDropdown: NavbarTitles =
            new NavbarTitles("Listagens",
                [
                    new NavbarItem("NavBar.Tab.Assistances.With.StartDate.Different.Than.EndDate", RoutesObject.kpis.details, ["Técnico Oficina", "Técnico Escritório", "Admin"], "isActiveKpiModule"),
                    new NavbarItem("NavBar.Tab.Assistances.With.Registered.Time.Greater.Than.7.Hours", RoutesObject.kpis.create, ["Técnico Oficina", "Técnico Escritório", "Admin"], "isActiveKpiModule"),
                    new NavbarItem("NavBar.Tab.Assistances.With.Open.Registered.Time", RoutesObject.kpis.list3 ?? 'Rota Undefined', ["Técnico Oficina", "Técnico Escritório", "Admin"], "isActiveKpiModule"),
                    new NavbarItem("NavBar.Tab.Open.Assistances.Greater.Than.10.Days", RoutesObject.kpis.list4 ?? 'Rota Undefined', ["Técnico Oficina", "Técnico Escritório", "Admin"], "isActiveKpiModule"),
                    new NavbarItem("NavBar.Tab.Brand.And.Model.List", RoutesObject.kpis.list2 ?? 'Rota Undefined', ["Técnico Oficina", "Técnico Escritório", "Admin"], "isActiveKpiModule"),
                ], ["Técnico Oficina", "Técnico Escritório", "Admin"]);

        // Dropdown para configurações
        const FourthDropdown: NavbarTitles =
            new NavbarTitles("Configurações",
                [
                    new NavbarItem("Navbar.Tab.Users", RoutesObject.users.list, ["Admin"]),
                    new NavbarItem("Navbar.Tab.FileTypes", RoutesObject.fileTypes.list, ["Técnico Escritório", "Admin"]),
                    new NavbarItem("Navbar.Tab.Settings", RoutesObject.settings.list, ["Admin"]),
                    new NavbarItem("Navbar.Tab.SettingsV2", RoutesObject.settingsv2.list, ["Admin"]),
                    new NavbarItem("Navbar.Tab.AuditLog", RoutesObject.auditLogs.list, ["Admin"]),
                    new NavbarItem("Navbar.Tab.Country", RoutesObject.countries.list, ["Técnico Escritório", "Admin"]),
                    new NavbarItem("Feriados", RoutesObject.Holidays.list, ["Técnico Escritório", "Admin"]),
                    new NavbarItem("Navbar.Tab.Import", RoutesObject.imports.list, ["Técnico Escritório", "Admin"]),
                    new NavbarItem("Navbar.Tab.Status", RoutesObject.status.list, ["Técnico de Escritório", "Admin"]),
                    new NavbarItem("Navbar.Tab.Version", RoutesObject.version.details, ["Admin"]),
                ], ["Técnico Escritório", "Admin"]);

        try {

            let navbarTitle: NavbarTitles[];
            navbarTitle = [FirstDropdown, SecondDropdown, ThirdDropdown, KpisDropdown, FourthDropdown];
            return navbarTitle;
        } catch (error) {
            return [];
        }
    }
}

export class NavbarItem {
    public readonly label: string;
    public readonly path: string;
    public readonly requiredRoles?: string[];
    public readonly moduleName?: string;
    public readonly newTab?: boolean;

    constructor(label: string, path: string, requiredRoles?: string[], moduleName?: string, newTab?: boolean) {
        this.label = label;
        this.path = path;
        this.requiredRoles = requiredRoles;
        this.moduleName = moduleName;
        this.newTab = newTab;
    }

    public IsVisible(user: AuthDTO | null): boolean {
        if (typeof user == "undefined" || user == null) return false;

        if (
            typeof this.requiredRoles === "undefined" ||
            this.requiredRoles == null ||
            this.requiredRoles.length <= 0
        )
            return true;

        if (typeof user.roles === "undefined" || user.roles == null || user.roles.length <= 0)
            return false;

        var userHasSomeRole: boolean = this.requiredRoles.some((r) => user!.roles!.includes(r));
        return userHasSomeRole;
    }
}

export async function initializeNavbar(): Promise<NavbarTitles[]> {
    const settingValue = new SettingValue();
    return settingValue.initializeNavbar();
}

export async function getNavbarTitles(): Promise<NavbarTitles[]> {
    const settingValue = new SettingValue();
    return settingValue.initializeNavbar();
}
